var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-uploader',_vm._b({attrs:{"after-read":_vm.afterRead,"before-delete":_vm.beforeDelete},model:{value:(_vm.fileList),callback:function ($$v) {_vm.fileList=$$v},expression:"fileList"}},'van-uploader',_vm._attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }